import { render } from "./plan-detail.vue?vue&type=template&id=b1aac29c&scoped=true"
import script from "./plan-detail.vue?vue&type=script&lang=js"
export * from "./plan-detail.vue?vue&type=script&lang=js"

import "./plan-detail.vue?vue&type=style&index=0&id=b1aac29c&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1aac29c"]])

export default __exports__